/*
 * Filename: field-rule-array.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const FieldRulesObject = types.model({
    FieldRuleObject: types.optional(types.frozen(), {}),
    FieldRuleElement: types.optional(types.frozen(), {}),
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
    addEditRule(objectName: string, newRuleObject: any) {
        if (Object.keys(self.FieldRuleObject).length === 0) {
            self.FieldRuleObject = { [objectName]: newRuleObject };
        } else {
            if (self.FieldRuleObject.hasOwnProperty(objectName)) {
                const newRulesObjectKeys: any = Object.keys(newRuleObject);
                newRulesObjectKeys.forEach((ruleKey: any) => {
                    if (!self.FieldRuleObject[objectName].hasOwnProperty(ruleKey)) {
                        const existingRuleObject = { ...self.FieldRuleObject };
                        existingRuleObject[objectName] = { ...existingRuleObject[objectName], [ruleKey]: newRuleObject[ruleKey] };
                        self.FieldRuleObject = existingRuleObject;
                    } else {
                        const existingFieldObject = { ...self.FieldRuleObject };
                        const existingRuleObject = { ...existingFieldObject[objectName] };
                        existingRuleObject[ruleKey] = newRuleObject[ruleKey];
                        existingFieldObject[objectName] = existingRuleObject;
                        self.FieldRuleObject = existingFieldObject;
                    }
                });
            }
            else {
                let fieldRuleObject = { ...self.FieldRuleObject };
                fieldRuleObject = { ...fieldRuleObject, [objectName]: newRuleObject };
                self.FieldRuleObject = fieldRuleObject;
            }
        }
    },
    deleteAppliedRule(objectName: string, deleteRuleObject: any) {
        const existingFieldObject = { ...self.FieldRuleObject };
        const existingRuleObject = { ...existingFieldObject[objectName] };
        const existingRuleKeys = Object.keys(existingRuleObject);
        if (existingRuleKeys.length > 1) {
            delete existingRuleObject[deleteRuleObject];
            existingFieldObject[objectName] = existingRuleObject;
        } else {
            delete existingFieldObject[objectName];
        }
        self.FieldRuleObject = existingFieldObject;

    },
    addPickListSourceRule(objectName: string, pickListSource: any) {

        const picklistValueSource = { [objectName]: pickListSource[objectName] };
        if (Object.keys(self.FieldRuleObject).length === 0) {
            self.FieldRuleObject = { [objectName]: {picklistValueSource} };
        } else {
            if (self.FieldRuleObject.hasOwnProperty(objectName)) {
                // const newRulesObjectKeys: any = Object.keys(newRuleObject);
                // newRulesObjectKeys.map((ruleKey: any) => {
                if (!self.FieldRuleObject[objectName].hasOwnProperty('picklistValueSource')) {
                    const existingRuleObject = { ...self.FieldRuleObject };
                    existingRuleObject[objectName] = { ...existingRuleObject[objectName], picklistValueSource };
                    self.FieldRuleObject = existingRuleObject;
                } else {
                    const existingFieldObject = { ...self.FieldRuleObject };
                    const existingRuleObject = { ...existingFieldObject[objectName] };
                    existingRuleObject['picklistValueSource'] = { [objectName]: pickListSource[objectName] };
                    existingFieldObject[objectName] = existingRuleObject;
                    self.FieldRuleObject = existingFieldObject;
                }
                // });
            }
            else {
                let fieldRuleObject = { ...self.FieldRuleObject };
                fieldRuleObject = { ...fieldRuleObject, picklistValueSource };
                self.FieldRuleObject = fieldRuleObject;
            }
        }
    },
    // setRuleElementObject(ObjectName:string , ruleType:string , ruleObject : {}){
    //     let ruleElements = {...self.FieldRuleElement};
    //     if(ruleElements.hasOwnProperty(ObjectName)){
    //         let ruleTypeObjectName = {...ruleElements[ObjectName]};
    //         ruleTypeObjectName[ruleType] = ruleObject;
    //         ruleElements[ObjectName] = ruleTypeObjectName;
    //     } else {
    //         ruleElements[ObjectName] = {[ruleType] : ruleObject};
    //     }
    //     self.FieldRuleElement = ruleElements;
    // },
    setInputRulesObject(deployedRules:any){
        self.FieldRuleObject = deployedRules;
    },
    // setRuleElements(deployedRuleElements:any){
    //     self.FieldRuleElement = deployedRuleElements;
    // }
}));
